export default "__VITE_ASSET__tt8IWNgx__"